<nb-actions [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-action (click)="report()">
    <nb-icon status="warning" icon="alert-triangle-outline"></nb-icon>
  </nb-action>
</nb-actions>
